// 1. React
import { memo, useEffect, useState } from "react";

// 2. Helpers
import { useTranslate } from "helpers";

// 3. Types
import { WarehouseLocationFormProps } from "./types";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { FleetWarehouse } from "services/api/fleet/warehouses/types";

// 4. API
import { getFleetWarehouseAPI } from "services/api/fleet/warehouses/api";

// 5. Forms & validation
import { validateYup } from "services/forms/validation/validation";
import { TIRE_SET_WAREHOUSE_LOCATION_EDIT_FORM_SCHEMA } from "./validation";

// 6. UI components
import WarehouseDropdown from "ui/components/Dropdown/WarehouseDropdown/WarehouseDropdown";
import { Loader } from "ui/components/Loader";

const WarehouseLocationForm: React.FC<WarehouseLocationFormProps> = (props) => {
    const { formValues, setFormValues, errors, setErrors, registerValidator } = props;

    const { t } = useTranslate();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        registerValidator(validateStep);
    }, [formValues]);

    const validateStep = () => {
        if (!setErrors)
            return true;

        const isValid = validateYup(
            formValues,
            TIRE_SET_WAREHOUSE_LOCATION_EDIT_FORM_SCHEMA,
            setErrors
        );

        return isValid;
    };

    const handleWarehouseChange = (e: any, name: string, item: DropdownOption) => {
        fetchWarehouse(item.value);
    }

    const fetchWarehouse = async (id: string) => {
        if (id === undefined) {
            return;
        }

        setIsLoading(true);

        let result: FleetWarehouse;
        try {
            result = await getFleetWarehouseAPI(id);
        } catch {
            setIsLoading(false);
            return;
        }

        setFormValues((prev) => ({
            ...prev,
            warehouse: result,
        }));

        setIsLoading(false);

        if (setErrors)
            setErrors({});
    };

    return (
        <>
            <div className="border border-slate-200 rounded-sm p-5">
                <div className="">
                    {/* <div className="flex items-center gap-3 py-3 px-4 bg-blue-50  rounded-sm">
                        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                            <span className="text-blue-600 font-semibold text-sm">B</span></div>
                        <div>
                            <p className="text-sm font-semibold text-slate-800">BRO'N BRO d.o.o.</p>
                            <p className="text-xs text-slate-500">Vlasnik vozila je vaša tvrtka</p>
                        </div>
                    </div> */}
                    <div>

                        <div className="relative">
                            <div className=" rounded-sm relative ">
                                <WarehouseDropdown
                                    name="warehouse"
                                    label={t(
                                        "admin.fleet.tire.set.add.location.warehouse"
                                    )}
                                    placeholder={t(
                                        "admin.fleet.tire.set.add.location.warehouse.placeholder"
                                    )}
                                    value={formValues.warehouse && formValues.warehouse!.id}
                                    onChange={handleWarehouseChange}
                                    error={errors && errors.warehouse}
                                    required
                                />
                            </div>
                        </div>
                      
                    </div>
                </div>
            </div>

            <Loader isLoading={isLoading ?? false}> </Loader>
        </>
    );
};
export default memo(WarehouseLocationForm);
